/* eslint-disable import/prefer-default-export */
export function validateValidationCode(code: string) {
  if (code) {
    return code.length > 3 && code.length < 11;
  }
  return false;
}
